import React, { useEffect, useRef, useState } from "react";
import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHAreaDel } from "services/services-mia/RNHAreaDel";
import { RNHAreaGet } from "services/services-mia/RNHAreaGet";

export default function DeleteModal({ user, updateList, closeModal, setterRowSelected }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState();
    const formikRef = useRef();
    
    const getArticulosData = async () => {
        setIsLoading(true);
        const result = await RNHAreaGet(credentials, { rnhAreaId: user.id })
        formikRef.current.setValues({
            id: result[0].rnhAreaId,
            nombre: result[0].rnhAreaNombre,
            cod: result[0].rnhAreaCod,
            zonaId: result[0].rnhAreaZonaId,
            wkt: result[0].rnhAreaWKT,
            version: result[0].RNESArticuloVersion,
        });
        setData(result[0]);
        setIsLoading(false);
    }
    const handleDeleteArea = async (values) => {
        const response = await RNHAreaDel(
            credentials,
            { id: data.rnhAreaId }
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Articulo eliminado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            setterRowSelected({ status: false, row: {} })
            closeModal();
        }
    }

    useEffect(() => {
        getArticulosData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                })
            }
            onSubmit={(values) => {
                handleDeleteArea(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikTextInput
                            fullWidth={true}
                            disabled={true}
                            name="nombre"
                            placeholder=""
                            labelText="Nombre del area"
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Eliminar" }}
                        onCloseModal={closeModal}
                    />
                    {(inRequest) && <CircularIndeterminate />}
                </div>
            </Form>
        </Formik>
    );
}
